import { capitalizeIfLower, formatDate, sortReplies } from '@btime/helpers'
import React from 'react'

import { FlexCol } from '../../../../components/structure/FlexGrid'
import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../../packages/kiti/components/presentation/Text'
import { useChildrenServiceOrders } from '../_load/ChildrenServiceOrderLoader'
import Accordion from '../../../../components/structure/accordion/Accordion'
import AccordionContent from '../../../../components/structure/accordion/AccordionContent'
import AccordionHeader from '../../../../components/structure/accordion/AccordionHeader'
import DynamicListCounters from '../../../../containers/dynamic/presentationList/DynamicListCounters'
import DynamicPresentationList from '../../../../containers/dynamic/presentationList/DynamicPresentationList'

const ChildrenRepliesAccordion = () => {
  const childrenServiceOrders = useChildrenServiceOrders()

  return childrenServiceOrders.map(serviceOrder => {
    const replies = sortReplies(serviceOrder.replies)

    return (
      <FlexCol key={serviceOrder.id}>
        <Accordion startsOpen lineBorder mediumPadding={false}>
          <AccordionHeader>
            <Grid justify="space-between">
              <div>
                <Title size="h4" noMargin>
                  {serviceOrder.name || capitalizeIfLower(serviceOrder.checklist.name)}
                </Title>
                <SmallText>
                  {serviceOrder.asset ? serviceOrder.asset.name : serviceOrder.place.name} |{' '}
                  {formatDate('DD MMM YYYY - HH:mm', serviceOrder.endDate)}
                </SmallText>
              </div>
              <DynamicListCounters replies={replies} />
            </Grid>
          </AccordionHeader>
          <AccordionContent>
            <DynamicPresentationList replies={replies} />
          </AccordionContent>
        </Accordion>
      </FlexCol>
    )
  })
}

export default ChildrenRepliesAccordion
